import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericExpansionPanel, GenericGrid, GenericDateInput, GenericSelectInput } from "views/Components/Generic";
import DateHelper from "core/DateHelper";
import { ProgramCodes, } from "views/Constants/Constant.js";
import LoadingComponent from "views/Components/LoadingComponent";
import ClientHelper from "core/ClientHelper";
import ParameterComponent from "views/Components/ParameterComponent";
import { GridColumnType } from "views/Constants/Constant";
import CustomerComponent from "views/Components/CustomerComponent";

class DailyInterestTransactions extends React.Component {
	constructor(props) {
		super(props);
		this.maxLength19 = { maxLength: 19 };

		this.emptyObject = {};
		this.sortedName = { Member: "Name" };
		this.initialModel = {
			Id: 0,
			UniqueClientId: ClientHelper.IsClient()
				? ClientHelper.GetClientRowId()
				: undefined,
			Customer: null,
			FromDate: null,
			ToDate: null,
			PaymentStatusId: null,
			CardTokenNumber: null,
			CustomerNumber: null
		};


		this.columns = [
			{
				Header: "Statement Id",
				accessor: "StatementId",
			},
			{
				Header: "Transaction Type",
				accessor: "TransactionType",
			},
			{
				Header: "Payment Status",
				accessor: "PaymentStatus",
			},
			{
				Header: "Statement Date",
				accessor: "StatementDate",
				type: GridColumnType.DateTime
			},
			{
				Header: "Customer Number",
				accessor: "CustomerNumber",
			},
			{
				Header: "Customer Name",
				accessor: "CustomerName",
			},
			{
				Header: "Card Token",
				accessor: "CardTokenNumber",
			},
			{
				Header: "Amount",
				accessor: "Amount",
				type: GridColumnType.Money,
				ColumnType: GridColumnType.Money
			},
			{
				Header: "Waiting Amount",
				accessor: "WaitingAmount",
				type: GridColumnType.Money,
				ColumnType: GridColumnType.Money
			},
			{
				Header: "Collected Amount",
				accessor: "CollectedAmount",
				type: GridColumnType.Money,
				ColumnType: GridColumnType.Money
			},
			{
				Header: "Total Collected Amount",
				accessor: "TotalCollectedAmount",
				type: GridColumnType.Money,
				ColumnType: GridColumnType.Money
			},
			{
				Header: "Process Date",
				accessor: "ProcessDate",
				type: GridColumnType.DateTime
			},
			{
				Header: "Insert User",
				accessor: "InsertUser",
			},
			{
				Header: "Update Date",
				accessor: "UpdateDateTime",
				type: GridColumnType.DateTime
			},



		];

		this.LMSPaymentStatus = {
			ParameterCode: "LMSPaymentStatus",
		};



		this.state = {
			model: this.initialModel,
			isLoading: false,
			checkedAccounts: [],
			ClientTypeParameter: {},
			panelTransactionIsActive: false,
			list: [],
			isBackOffice: ClientHelper.IsBackOffice()
		};
	}

	componentDidMount() {
		const { setAppCenterTitle, setAppLeftTitle } = this.props;

		if (setAppCenterTitle) {
			setAppCenterTitle("LOAN MANAGEMENT SYSTEM");
		}
		if (setAppLeftTitle) {
			setAppLeftTitle("Interest Payment Status");
		}
	}

	Search = async () => {
		if (!this.Validate()) return;
		const { ExecuteApiPost } = this.props;
		const model = { ...this.state.model };
		const request = {
			FromDate: model.FromDate,
			ToDate: model.ToDate,
			CustomerNumber: model.Customer != null ? model.Customer.CustomerNumber : null,
			UniqueClientId: model.UniqueClientId,
			PaymentStatusId: model.PaymentStatusId,
			CardTokenNumber: model.CardTokenNumber,

		};
		var result = await ExecuteApiPost(
			"/lmsapi/v1.0/Statement/SecuredCardDailyTransactionInterestCollenctionList",
			request,
			null,
			null,
			null
		);


		if (result != null) {
			this.setState({ list: result || [] });
		}
	};

	Clear = () => {
		this.setState({ model: {}, list: [], selected: null, checkedAccounts: [] });
	};

	Validate = () => {
		var { model } = this.state;
		const { showValidationErrors } = this.props;
		var errors = [];
		if (model.FromDate == undefined || model.FromDate == null) {
			errors.push("From date must be select!");
		}
		if (model.ToDate == undefined || model.ToDate == null) {
			errors.push("To date must be select!");
		}
		if (model.UniqueClientId == undefined || model.UniqueClientId == null || model.UniqueClientId <= 0) {
			errors.push("Client must be select!");
		}

		if (errors.length > 0) {
			showValidationErrors(errors);

			return false;
		}

		return true;
	};

	GetRenderItemUniqueClient = (x) => {
		this.renderItemUniqueClient = `${x.Name} - ${x.UniqueClientId}`;
		return this.renderItemUniqueClient;
	};

	handleChange = (name, newValue, data) => {
		const model = {
			...this.state.model,
		};
		model[name] = newValue;
		this.setState({ model });
	};
	handleChangeForCustomer = (name, newValue) => {
		const model = { ...this.state.model };
		const initialModel = { ...this.initialModel };
		if (name === "Customer") {
			if (newValue != null) {
				model.Customer = newValue;
				if (newValue.Accounts != null && newValue.Accounts.length > 0) {
					model.CustomerNumber = newValue.Accounts[0].CustomerNumber;
				} else {
					model.CustomerNumber = null;
				}
			} else {
				model.Customer = initialModel.Customer;
			}
		}
		this.setState({ model });
	};
	HandleClear = () => {
		this.setState({
			model: this.initialModel,
			filterModel: {},
			selected: null,
			list: [],
		});
	};
	render() {
		const { model, ReadOnly, list, panelTransactionIsActive, isBackOffice } = this.state;
		const { Disabled } = this.props;
		var IsClient = ClientHelper.IsClient();

		return (
			<div>
				<ButtonToolbar
					ButtonList={[
						{
							Code: "Search",
							Disabled: Disabled,
							OnClick: this.Search,
						},
						{
							Code: "Clear",
							Disabled: Disabled,
							OnClick: this.HandleClear,
						},
					]}
					menuId={this.props.menuId}
					ApprovalData={this.props.ApprovalData}
					After={this.props.After}
				/>
				<LoadingComponent Show={this.state.isLoading} />

				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Filter">
									<GridContainer>
										<GridItem xs={2}>
											<GenericSelectInput
												Name="UniqueClientId"
												LabelText="Client"
												Method="POST"
												Url="/bankapi/v1.0/BankCustomer/Search"
												Parameter={{}}
												DataRoot="Item"
												KeyValueMember="Id"
												RenderItem={(d) => `${d.UniqueClientId} - ${d.Name}`}
												Value={model.UniqueClientId || ""}
												ValueChanged={this.handleChange}
												CanClear
												All
												Required
												Disabled={IsClient}
												DefaultIndex={IsClient ? 0 : -1}
											/>
										</GridItem>
										<GridItem xs={2}>
											<ParameterComponent
												LabelText="Payment Status"
												Name="PaymentStatusId"
												LabelMd={4}
												ParameterCode={this.LMSPaymentStatus.ParameterCode}
												Value={model.PaymentStatusId}
												ValueChanged={this.handleChange}
											/>
										</GridItem>
										<GridItem xs={2}>
											<GenericDateInput
												Name="FromDate"
												LabelText="From Date"
												Value={model.FromDate}
												ValueChanged={this.handleChange}
												MaxDate={model.ToDate || DateHelper.GetDateTimeLocal()}
												IncludeTime={false}
												Utc
												Required
											/>
										</GridItem>
										<GridItem xs={2}>
											<GenericDateInput
												Name="ToDate"
												LabelText="To Date"
												Value={model.ToDate}
												ValueChanged={this.handleChange}
												MinDate={model.FromDate}
												IncludeTime={false}
												Utc
												Required
											/>
										</GridItem>
										<GridItem xs={2}>
											<CustomerComponent
												LabelMd={4}
												CustomerNumber={model.Customer === null ? null : model.Customer.CustomerNumber}
												UniqueClientId={model.UniqueClientId}
												FillCallback={customer => { this.handleChangeForCustomer("Customer", customer); }}
												Programs={[ProgramCodes.Prepaid]} />
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>

						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel
									IsActive
									Title="Interest Payment Status">
									<GridContainer>
										<GridItem xs={12}>
											<GridContainer spacing={16}>
												<GridItem xs={12}>
													<GenericGrid
														Data={list}
														Columns={this.columns}
														ShowPagination={true}
														PageSize={100}
														IsSorted={false}
													/>
												</GridItem>
											</GridContainer>
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

DailyInterestTransactions.propTypes = {
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	ExecuteApiPost: PropTypes.func,
	Disabled: PropTypes.bool,
	menuId: PropTypes.any,
	ApprovalData: PropTypes.any,
	After: PropTypes.any,
};

export default DailyInterestTransactions;
